/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/zoom" */ '@atlassian/logo-third-party/zoom'
		).then((m) => m.ZoomIcon),
	{ moduleId: '@atlassian/logo-third-party/zoom' },
);

const LazyZoomIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-zoom" */ './utils').then((m) => m.ZoomIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/zoom/icon' },
);

const LazyZoomSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-zoom-search-result" */ './utils').then(
			(m) => m.ZoomSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ZoomIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyZoomIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ZoomSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyZoomSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
